module.exports = "<div class=\"transition-bar angular-animate\" ng-if=$ctrl.active><div class=t-bar></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/ui/transition-bar/transition-bar.component.html
// module id = 1016
// module chunks = 31